var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 14.9831V33.9165C26.6668 36.3332 24.9335 37.3498 22.8168 36.1832L16.2668 32.5332C15.5668 32.1498 14.4335 32.1498 13.7335 32.5332L7.1835 36.1832C5.06683 37.3498 3.3335 36.3332 3.3335 33.9165V14.9831C3.3335 12.1331 5.66681 9.7998 8.51681 9.7998H21.4835C24.3335 9.7998 26.6668 12.1331 26.6668 14.9831Z",
    stroke: "#7BD96A",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6668 8.51681V27.4502C36.6668 29.8668 34.9335 30.8835 32.8168 29.7168L26.6668 26.2835V14.9835C26.6668 12.1335 24.3335 9.80016 21.4835 9.80016H13.3335V8.51681C13.3335 5.66681 15.6668 3.3335 18.5168 3.3335H31.4835C34.3335 3.3335 36.6668 5.66681 36.6668 8.51681Z",
    stroke: "#7BD96A",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 20H18.3332",
    stroke: "#7BD96A",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.3332V16.6665",
    stroke: "#7BD96A",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAdd);
export default __webpack_public_path__ + "static/media/saveAdd.4fcb02dd44a921b6caa319d9d1ee73b4.svg";
export { ForwardRef as ReactComponent };